// ExpandableCard/index.js

import ExpandableCard from './ExpandableCard';
export default ExpandableCard;
